
import { IElForm } from '@/types/element';
import { IContact } from '@/types/models';
import { defineComponent, PropType } from 'vue';

interface IForm {
  name: string;
  company: string;
  mobile: string;
  content: string;
  memo: string;
}

interface IState {
  form: IForm;
}

export default defineComponent({
  props: {
    contact: {
      type: Object as PropType<IContact>,
      required: true,
    },
  },
  emits: ['cancel', 'submit'],
  data() {
    return {
      form: {
        name: this.contact.name,
        company: this.contact.company,
        mobile: this.contact.mobile,
        content: this.contact.content,
        memo: this.contact.memo,
      },
    } as IState;
  },
  methods: {
    btnCancelClick() {
      this.$emit('cancel');
    },

    btnSubmitClick() {
      (this.$refs.form as IElForm).validate((valid) => {
        if (valid) {
          this.$emit('submit', this.form.memo);
        }
      });
    },
  },
  watch: {
    contact(value: IContact) {
      this.form.name = value.name;
      this.form.company = value.company;
      this.form.mobile = value.mobile;
      this.form.content = value.content;
      this.form.memo = value.memo;
    },
  },
});
